<script>
	import Chart from 'chart.js';
	import {generateChart, mixins as barChartMixins} from "vue-chartjs";

	// load reactions
	import {loadImage} from "@/utils";

	var reactions = [
		{
			label: "angry",
			url: require("@/assets/reactions/Angry.svg"),
		},
		{
			label: "haha",
			url: require("@/assets/reactions/Haha.svg"),
		},
		{
			label: "like",
			url: require("@/assets/reactions/Like.svg"),
		},
		{
			label: "love",
			url: require("@/assets/reactions/Love.svg"),
		},
		{
			label: "sad",
			url: require("@/assets/reactions/Sad.svg"),
		},
		{
			label: "wow",
			url: require("@/assets/reactions/Wow.svg"),
		}
	].map(react => {
		react.img = loadImage(react.url);
		return react;
	});

	function getReaction(label) {
		const found = reactions.find(react => react.label === label);
		return found ? found.img
			: new Promise((res, rej) => rej(new Error(`No reaction found with label: ${label}`)));
	}

	const {reactiveProp} = barChartMixins;

	Chart.defaults.reactionBarChart = Chart.defaults.bar;

	Chart.controllers.reactionBarChart = Chart.controllers.bar.extend({
		async draw() {
			Chart.controllers.bar.prototype.draw.apply(this, arguments);

			const meta = this.getMeta();

			for (let data of meta.data) {
				const {x, y, datasetLabel: label} = data._view;
				// const imgSize = data._xScale.options.barThickness;
				const imgSize = 20;
				const ctx = this.chart.chart.ctx;
				const img = await getReaction(label);
				ctx.save();
				ctx.globalCompositeOperation = 'destination-over';
				ctx.drawImage(img, x - (imgSize / 2), y - (imgSize+3), imgSize, imgSize);
				ctx.restore();
			}
		}
	});

	const ReactionBarChart = generateChart('reaction-bar-chart', 'reactionBarChart');

	export default {
		extends: ReactionBarChart,

		name: "ReactionBarChart",

		mixins: [reactiveProp],

		props: {
			options: {
				type: Object,
			}
		},

		mounted() {
			this.addPlugin({
				beforeInit(chart) {
					chart.legend.afterFit = function () {
						this.height = this.height + 15;
					}
				}
			});

			this.$nextTick(() => {
				this.renderChart(this.chartData, this.options);
			})
		}
	}
</script>
